import { render, staticRenderFns } from "./zxsjj.vue?vue&type=template&id=778f0783&scoped=true&"
import script from "./zxsjj.vue?vue&type=script&lang=js&"
export * from "./zxsjj.vue?vue&type=script&lang=js&"
import style0 from "./zxsjj.vue?vue&type=style&index=0&id=778f0783&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778f0783",
  null
  
)

export default component.exports